import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { FaFile, FaFileImage, FaFilePdf } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import calender from "../../assets/images/Calendar3.svg";
import del from "../../assets/images/delete.svg";
import Header from "../../layouts/Header";
import "../../assets/styles/local/profile.css";
import "../../assets/styles/local/AddMember.css";
// import lay from "../../assets/images/layer1.svg"
import adddoc from "../../assets/images/add56.svg";
// import duc from "../../assets/images/duc5.jpg";
import moment from "moment";
import { Col, Modal } from "react-bootstrap";
import CurrencyInput from "react-currency-input";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import { AiOutlinePlus } from "react-icons/ai";
import { BsChevronDown, BsChevronLeft, BsChevronRight } from "react-icons/bs";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useDispatch, useSelector } from "react-redux";
import AppDatePicker from "../../components/Common/AppDatePicker";
import DeletePopUp from "../../components/Dailogs/DeletePopUp";
import {
  AddDocToUser,
  AddJobtypes,
  DeleteJobtypes,
  FetchJobtypes,
  FetchRoleModuleAccess,
  UpdateJobtypes,
  createUser,
  fetchLanguages,
  fetchIdsType,
  fetchEmployeeType,
  fetchContractType,
  fetchCompanyCar,
  fetchReasons,
  FetchActiveUser,
  fetchUserCertification,
  insertDocToS3,
  SendEmailforRegistering,
  FetchUserTitles,
  AddUpdateDeleteUserTitle,
} from "../../redux/actions/action";
import { API_URL } from "../../redux/constants/type";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import edit from "..//..//assets//icons/edit-2.svg";
import noteyeIcon from "..//../assets/icons/Notshow.svg";
import eyeIcon from "..//../assets/icons/eye.svg";
import DocumentUploaderWithProgress from "../../components/Common/Document_Uploader_With_Progress";
import TimeOff from "../../components/Update_Member/TimeOff";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import {
  SelectNav,
  PersonalInfoForm,
  LegalInformationForm,
  BankAccountForm,
  CompanyCarForm,
  CertificationList,
  ProvidedItems,
  WageScreen,
  TimeOffScreen,
  CustomDropdown,
} from "../../utils/addMember/helpers";
import {
  informationNavItems,
  documentNavItems,
} from "../../utils/addMember/navItems";
import { PlusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { PlusOneOutlined } from "@mui/icons-material";
import { handleGeneralNotification } from "../../utils/helpers/notifications";

const errorFields = {
  information: {
    name: "Please enter your name !",
    email: "Please enter your email !",
    password: "Please enter password.",
    phoneNumber: "Please enter your phone number",
    date: "Please enter date.",
    address: "Please enter address",
    zipCode: "Please enter ZIP-Code",
    language: "Please enter language",
  },
};
const errorBools = {
  name: false,
  email: false,
  password: false,
  phoneNumber: false,
  date: false,
  address: false,
  zipCode: false,
  language: false,
};

const AddMember = () => {
  const roleAccess = window.localStorage.getItem("roleid");
  const packageID = window.localStorage.getItem("packageId");

  const refNewStandardWageInput = useRef(null);
  const initialRender = React.useRef(true);
  const [errors, setErrors] = useState(errorBools);
  const [information, setInfomation] = useState(true);
  const [wage, setWage] = useState(false);
  const [document, setDocument] = useState(false);
  const [timeOff, setTimeOff] = useState(false);
  const [FetchCompanyThemRes, setFetchCompanyThemRes] = useState([]);
  const [textcolor, setTextcolor] = useState("");
  const [backgroundcolor, setBackgroundcolor] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [leaves, setLeaves] = useState([]);
  const [searchlang, setSearchlang] = useState("");
  const [showPriorityDrop, setShowPriorityDrop] = useState(false);
  const [fetchLanguageList, setFetchLanguageList] = useState([]);
  const [newUser, setNewUser] = useState([]);
  const [newdoc, setNewdoc] = useState([]);
  const [userData, setUserdata] = useState([]);
  const [showStatusDrop2, setShowStatusDrop2] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [dateError, setDateError] = useState(false);

  const [authorisationRole, setAuthorisationRole] = useState("User");
  const FetchCompanyDetails1 = useSelector(
    (state) => state.user.FetchCompanyDetails,
  );
  const [navErrors, setNavErrors] = useState({
    firstName: false,
    email: false,
    password: false,
    initials: false,
    alreadyExist: false,
  });
  const fetchActiveUser = useSelector((state) => state.user.fetchActiveUser);
  const dispatch = useDispatch();
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [deleteDocument, setDeleteDocument] = useState(false);
  const [deleteRowIndex, setDeleteRowIndex] = useState(null);
  const companyid = window.localStorage.getItem("companyid");
  const userimag = window.localStorage.getItem("userimageurl");
  const userfirstname = window.localStorage.getItem("firstname");
  const userlastname = window.localStorage.getItem("lastname");
  const languages = window.localStorage.getItem("language");
  const newCreateUserData = useSelector((state) => state.user.userCreate);
  const UpdateJobtypesRes = useSelector((state) => state.user.UpdateJobtypes);
  const FetchJobtypesdata = useSelector((state) => state.user.FetchJobtypes);

  const FetchUserData = useSelector(
    (state) => state.user.fetchActiveUser?.data,
  );
  const Document = useSelector((state) => state.user.fetchDocument);
  const AddJobtypesData = useSelector((state) => state.user.AddJobtypes);
  const roleModuleData = useSelector(
    (state) => state.user.FetchRoleModuleAccess,
  );
  const FetchLanguagesData = useSelector(
    (state) => state.user.FetchlanguagesList,
  );

  const certificationList = useSelector(
    (state) => state.user.fetchedCertification,
  );
  const [canGoBack, setCanGoBack] = useState(false);
  const addfile = useSelector((state) => state.user.AddDocument);
  const userid = window.localStorage.getItem("userid");
  const [showStatusDrop, setShowStatusDrop] = useState(false);
  const [showTypeDrop, setShowTypeDrop] = useState(false);
  const [showContactDrop, setShowContactDrop] = useState(false);
  const [showPaymentDrop, setShowPaymentDrop] = useState(false);
  const [showJobDrop, setShowJobDrop] = useState(false);
  const [jobTypeEdit, setJobTypeEdit] = useState(false);
  const [editJobValue, setEditJobValue] = useState("");
  const [jobname, setJobname] = useState("");

  const [jobValue, setJobValue] = useState("");
  // const [lastname, setLastname] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [ziPcode, setZipcode] = useState("");
  const [taxnumber, setTaxnumber] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [securitynumber, setSecuritynumber] = useState("");
  const [dateofbirth, setDateofbirth] = useState("");
  const [language, setLanguage] = useState("English");
  const [wagerate, setWagerate] = useState("");
  const [billrate, setBillrate] = useState("");
  const [fulLenghtDocAdd, setFulLenghtDocAdd] = useState(false);
  const [oddWorkingHours, setOddWorkingHours] = useState(0);
  const [evenWorkingHours, setEvenWorkingHours] = useState(0);
  const [type, setType] = useState("Hourly");
  const [payment, setPayment] = useState("");
  const [password, setPassword] = useState("");
  const [abbreviation, setAbbreviation] = useState("");
  const [isactive, setIsactive] = useState(true);
  const [jobpost, setJobpost] = useState("");
  const [iscurrentcompany, setIscurrentcompany] = useState("");
  const [isrequiretimesheetapproval, , setIsrequiretimesheetapproval] =
    useState("");
  const [isallowmanualtime, setIsallowmanualtime] = useState("");
  const [contracttype, setContracttype] = useState("Contract");
  const [paymentperiod, setPaymentperiod] = useState("Monthly");
  const roleID = window.localStorage.getItem("roleid");
  const [jobid, setJobid] = useState("3fa85f64-5717-4562-b3fc-2c963f66afa6");
  const [roles, setRoles] = useState("");
  const [roleid, setRoleid] = useState(process.env.REACT_APP_IS_VIEWER);

  const [select, setSelect] = useState("NL");
  const profileUploadRef = useRef();
  const onSelect = (code) => setSelect(code);
  const [comp, setComp] = useState("");
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [changeComp, setChangeComp] = useState("");
  const [docIAdd, setdocIAdd] = useState();
  const [imageUrl, setImageUrl] = useState("");
  const [popups, setPopups] = useState(false);
  const [docname, setDocname] = useState("");
  const [docsize, setDocsize] = useState("");
  const [docdate, setDocdate] = useState("");
  const [up, setUp] = useState("");
  const [rolename, setRolename] = useState("");
  const [imgurl, setImgurl] = useState("");
  const [fullName, setFullName] = useState("");
  const [jobpostList, setJobpostList] = useState([]);
  const [filelist, setFilelist] = useState([]);
  const history = useHistory();
  const [error, setError] = useState(false);
  const [phone, setPhone] = useState("");
  const firstName = fullName.split(" ")[0];
  const lastName = fullName.split(" ")[1] || "";
  const [invietsms, setInvietsms] = useState("");
  const [errorMessage, setErrorMessage] = useState(false);
  const [indexJobtype, setIndexJobtype] = useState();
  const [paymentaccount, setPaymentaccount] = useState("");
  const [description, setDescription] = useState("");
  const [hoverJobList, setHoverJobList] = useState(false);
  const [indexJobtypeIndex, setIndexJobtypeIndex] = useState("");
  const [roleOwnerDiseble, setRoleOwnerDiseble] = useState(false);
  const [roleManagerDiseble, setRoleManagerDiseble] = useState(false);
  const [roleUserViewerDiseble, setRoleUserViewerDiseble] = useState(false);
  const [activeSlider, setActiveSlider] = useState(false);
  const [weekHours, setWeekHours] = useState("");
  const [payroll, setPayRoll] = useState(false);
  const [timesheetapproval, setTimeSheetApproval] = useState(false);
  const [totalCertifications, setTotalCertifications] = useState([]);
  const [selectedInformationNav, setSelectedInformationNav] = useState(
    informationNavItems[0],
  );
  const [selectedDocumentNav, setSelectedDocumentNav] = useState(
    documentNavItems[0],
  );

  const { idsType, employeeType, contractType, companyCar, fetchedReasons } =
    useSelector((state) => state.user);

  const { insertedDoc } = useSelector((state) => state.user);
  const [personalForm, setPersonalForm] = useState({});

  const [legalForm, setLegalForm] = useState({});

  const [transportForm, setTransportForm] = useState({});
  const [bankAccounts, setBankAccounts] = useState([]);

  const [providedItems, setProvidedItems] = useState([]);

  const [certificationsList, setCertificationsList] = useState([]);
  const [timeOffEntries, setTimeOffEntries] = useState([]);
  const [applyToAllYear, setApplyToAllYear] = useState(false);

  const [paginationObj, setPaginationObj] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });
  const [fetchTransAddMemberList, setFetchTransAddMemberList] = useState({});
  const t = (key) => fetchTransAddMemberList?.[key] || "";
  const [evenDays, setEvenDays] = useState({
    // monday: "8",
    // tuesday: "8",
    // wednesday: "8",
    // thursday: "8",
    // friday: "8",
    // saturday: "0",
    // sunday: "0",
  });
  useEffect(() => {
    if (fetchTransAddMemberList?.length) {
      setEvenDays({
        [t("monday") || "monday"]: "8",
        [t("tuesday") || "tuesday"]: "8",
        [t("wednesday") || "wednesday"]: "8",
        [t("thursday") || "thursday"]: "8",
        [t("friday") || "friday"]: "8",
        [t("saturday") || "saturday"]: "0",
        [t("sunday") || "sunday"]: "0",
      });
    }
  }, [fetchTransAddMemberList]);

  const [oddDays, setOddDays] = useState({
    // monday: "8",
    // tuesday: "8",
    // wednesday: "8",
    // thursday: "8",
    // friday: "8",
    // saturday: "0",
    // sunday: "0",
  });
  useEffect(() => {
    if (fetchTransAddMemberList?.length) {
      setOddDays({
        [t("monday") || "monday"]: "8",
        [t("tuesday") || "tuesday"]: "8",
        [t("wednesday") || "wednesday"]: "8",
        [t("thursday") || "thursday"]: "8",
        [t("friday") || "friday"]: "8",
        [t("saturday") || "saturday"]: "0",
        [t("sunday") || "sunday"]: "0",
      });
    }
  }, [fetchTransAddMemberList]);

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      // backgroundColor: theme.palette.common.white,
      fontWeight: 400,
      color: "#333333",
      fontSize: "14px",
      background: "#F1F1F1 0% 0% no-repeat padding-box",
      boxShadow: "0px 3px 6px #00000029",
      opacity: 1,
    },
  }));
  let hiddenFileInput = useRef(null);

  const onFileUploaded = (data) => {
    setChangeComp(data);
    const modifiedContacts = filelist;
    let icon = null;

    switch (data.type) {
      case "pdf":
        icon = <FaFilePdf color="#475757" fontSize={15} />;
        break;
      case "jpg":
      case "jpge":
      case "png":
      case "svg":
        icon = <FaFileImage color="#475757" fontSize={15} />;
        break;
      default:
        icon = <FaFile color="#475757" fontSize={15} />;
        break;
    }

    modifiedContacts.push({
      userid: userid,
      documentname: data[0].name,
      documentextension: data[0].type,
      documentcontent: "string",
      link: data[0].link,
      documentsize: data[0].size,
      icon: icon,
      type: selectedDocumentNav,
    });

    setFilelist([...modifiedContacts]);
  };

  useEffect(() => {
    fetchScreenTranslations("Add-Co-Workers").then((res) => {
      setFetchTransAddMemberList(res);
    });
    dispatch(FetchRoleModuleAccess(roleID));
    dispatch(fetchLanguages());
    dispatch(FetchJobtypes());
    dispatch(fetchIdsType());
    dispatch(fetchEmployeeType());
    dispatch(fetchContractType());
    dispatch(fetchCompanyCar());
    dispatch(fetchReasons());
    dispatch(FetchUserTitles());
  }, []);

  useEffect(() => {
    if (FetchJobtypesdata != null) {
      if (FetchJobtypesdata?.data?.status === true) {
        setJobpostList(FetchJobtypesdata?.data?.data);
      } else {
      }
    }
  }, [FetchJobtypesdata]);

  useEffect(() => {
    if (UpdateJobtypesRes != null) {
      if (UpdateJobtypesRes?.status === true) {
        dispatch(FetchJobtypes());
      } else {
      }
    }
  }, [UpdateJobtypesRes]);

  useEffect(() => {
    if (FetchLanguagesData?.data?.status == true) {
      setFetchLanguageList(FetchLanguagesData?.data?.data);
    }
  }, [FetchLanguagesData]);

  useEffect(() => {
    if (
      newCreateUserData != null &&
      Object.keys(newCreateUserData).length > 0
    ) {
      if (newCreateUserData?.status === true) {
        setTimeout(() => {
          let reqArray = [];
          filelist?.forEach((elements) => {
            reqArray.push({
              documentname: elements?.documentname,
              documentextension: elements?.documentextension,
              documentcontent: elements?.documentcontent,
              link: elements?.link,
              documentsize: elements?.documentsize,
              ispossibledelete: 0,
              islocked: 0,
              type: selectedDocumentNav,
            });
          });
          dispatch(
            AddDocToUser(userid, newCreateUserData?.data?.userid, filelist),
          );
          if (isactive === true) {
            axios({
              method: "post",
              url: `${API_URL}/api/User/SendEmail`,
              headers: {
                "Content-Type": "application/json",
              },
              data: {
                subject: "Registered",
                to: email,
                eventid: "08dc57cc-9bed-42f1-8a72-4a766eaf2001",
                name: firstName,
                companyid: companyid,
              },
            }).then((response) => {});
          }
          dispatch({ type: "USER_CREATE", data: {} });
          history.push("/member-list");
        }, 3000);

        // setJobpostList( newCreateUserData?.data?.data);
      } else {
        setInvietsms(newCreateUserData?.message);
        setErrorMessage(true);
      }
    }
  }, [newCreateUserData]);

  const calculatePagination = (pageNumber) => {
    let records = filelist || [];
    let tempPaginationObj = {
      totalRecords: records.filter((rec) => rec?.type === selectedDocumentNav)
        .length,
      currentPage: pageNumber,
      startRecordIndex: Math.max(10 * pageNumber - 9, 1),
      endRecordIndex: Math.min(
        10 * pageNumber,
        records.filter((rec) => rec?.type === selectedDocumentNav).length,
      ),
      totalPages: Math.ceil(
        records.filter((rec) => rec?.type === selectedDocumentNav).length / 10,
      ),
      records: records
        .filter((rec) => rec?.type === selectedDocumentNav)
        ?.slice((pageNumber - 1) * 10, pageNumber * 10),
    };
    setPaginationObj({ ...tempPaginationObj });
  };

  useEffect(() => {
    calculatePagination(1);
  }, [filelist, selectedDocumentNav]);

  useEffect(() => {
    dispatch(FetchActiveUser(companyid));
    dispatch(fetchUserCertification());
  }, []);

  useEffect(() => {
    if (addfile != null) {
      if (addfile.status == true) {
        // dispatch(Fetchdocumentbyuserid(userid))
      } else {
      }
    }
  }, [addfile]);

  useEffect(() => {
    console.log(paginationObj);
  }, [paginationObj]);

  useEffect(() => {
    if (AddJobtypesData != null) {
      if (AddJobtypesData?.status === true) {
        setJobid(AddJobtypesData?.data?.jobtypeid);
        // dispatch(Fetchdocumentbyuserid(userid))
        dispatch(FetchJobtypes());
        setShowJobDrop(false);
        setJobValue("");
        dispatch({ type: "SET_STATUS_FALSE" });
      } else {
      }
    }
  }, [AddJobtypesData]);

  const handleDeleteFun = () => {
    setImageUrl("");
    setDeleteModalShow(false);
  };
  const handleDeleteDocumentFun = () => {
    if (deleteRowIndex !== null) {
      let data = [...filelist];
      data.splice(deleteRowIndex, 1);
      setFilelist(data);
    }
    setDeleteDocument(false);
    setDeleteRowIndex(null);
  };

  const handelCancels = () => {
    // if (changeComp !== "") {
    //   setPopups(true);
    // } else {
    history.goBack();
    // window.location.reload();
    // setPopups(false);
    // }
  };

  const handleAddressSelect = (address) => {
    const { place_id } = address;
    geocodeByPlaceId(place_id)
      .then((res) => {
        console.log("Found the Address", res);

        if (res && res[0] && res[0].address_components) {
          const { long_name: postalCode = "" } =
            res[0].address_components.find((c) =>
              c.types.includes("postal_code"),
            ) || {};
          // setZipcode(postalCode);

          if (!address.description.includes(postalCode)) {
            setZipcode(postalCode);
          }
        }
      })
      .catch((err) => {
        console.log("Error while fetching address meta ", err);
      })
      .finally((done) => {
        console.log("Address API Call Completed ", done);
      });
  };

  useEffect(() => {
    if (!initialRender.current) {
      if (Document != null) {
        if (Document.status == true) {
          setNewdoc(Document.data);
          setDocname(Document.data[0]?.documentname);
          setDocsize(Document.data[0]?.documentsize);
          setDocdate(Document.data[0]?.date);
          setUp(Document.data[0]?.uploadedby);
        } else {
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [Document]);

  ////////////////////////////////
  const profileUpload = async (file) => {
    var formData = new FormData();
    formData.append("", file);
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      setImageUrl(response.data[0]);
    } catch (error) {}
  };

  ///////////////// THEME API FROM 222 TO 239///////////////////
  const [themeCompanyId, setThemeCompanyId] = useState("");

  React.useEffect(() => {
    if (!initialRender.current) {
      if (FetchCompanyDetails1 != null) {
        if (FetchCompanyDetails1?.status == true) {
          setFetchCompanyThemRes(FetchCompanyDetails1.data);
          setTextcolor(FetchCompanyDetails1.data[0]?.textcolor);
          setBackgroundcolor(FetchCompanyDetails1.data[0]?.backgroundcolor);
          // setCompenylLogo(FetchCompanyDetails1.data[0]?.companylogo)

          setThemeCompanyId(FetchCompanyDetails1.data[0]?.companyid);
        } else {
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [FetchCompanyDetails1]);

  const handleClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current.click();
  };

  useEffect(() => {
    console.log(hiddenFileInput.current);
  }, [hiddenFileInput.current]);

  /////////////////////UPADTE API DISPATCH FROM 257 TO 282///////////

  const convertDatesToISO = () => {
    const updatedData = leaves?.map((entry) => ({
      ...entry,
      from: entry.from
        ? moment.utc(entry.from, "DD.MM.YYYY").format("YYYY-MM-DD")
        : "",
      to: entry.to
        ? moment.utc(entry.to, "DD.MM.YYYY").format("YYYY-MM-DD")
        : "",
    }));
    return updatedData;
  };

  const handleChange = async () => {
    try {
      const res = await dispatch(
        createUser({
          companyid,
          roleid,
          ...personalForm,
          userLegal: [legalForm],
          userProvidedItem: providedItems,

          userBenefit: [transportForm],
          usertimeoff: timeOffEntries,
          userFinancial: bankAccounts,
          userCertification: totalCertifications,
          // isactive === false ? 0 : 1,
          imageUrl,
          billrate,
          contracttype,
          paymentperiod,
          type,
          wagerate,
          jobid,
          applyToAllYear: applyToAllYear ? 1 : 0,
          oddWorkingHours,
          evenWorkingHours,
          timesheetapproval: timesheetapproval ? 1 : 0,
          payroll: payroll ? 1 : 0,
          // leaveData,
          isverified: 0,
          isrequiretimesheetapproval: 0,
          isallowmanualtime: 0,
          isdeleted: 0,
          userlogtimer: [
            {
              userLogTimerid: "",
              type: "even",
              weekNumber: moment().week(),
              ...evenDays,
            },
            {
              userLogTimerid: "",
              type: "odd",
              weekNumber: moment().week(),
              ...oddDays,
            },
          ],
        }),
      );
      console.log("asc445", res);
      if (res?.status === false) {
        handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: res?.message,
          },
          false,
        );
        return; // यहीं से कोड रोक दें, आगे setCanGoBack(true) न होने दें
      }

      setCanGoBack(true);
    } catch (error) {}
  };
  const options = [{ value: "English" }, { value: "Dutch" }];
  // const typeoptions = [
  //   { value: "Hourly" },
  //   { value: "Daily" },
  //   { value: "Fixed" },
  // ];

  const typeoptions = [
    { value: t("Hourly") },
    { value: t("Daily") },
    { value: t("Fixed") },
  ];

  useEffect(() => {
    if (newCreateUserData?.message === "This Email Id Already Exist")
      setNavErrors((prev) => {
        return { ...prev, alreadyExist: true };
      });
  }, [newCreateUserData]);

  const contactTypeoptions = [
    { value: t("Contract ") },
    { value: t("Freelancer") },
  ];

  // const pymentoptions = [
  //   { value: "Weekly" },
  //   { value: "Daily" },
  //   { value: "Monthly" },
  // ];
  const pymentoptions = [
    { value: t("Weekly") },
    { value: t("Daily") },
    { value: t("Monthly") },
  ];

  const refContactTypeDropDownContainer = useRef();
  const refContactTypeDropDownContainerExclude = useRef();
  const handleMouseDownContactDD = (event) => {
    if (
      refContactTypeDropDownContainer.current &&
      !refContactTypeDropDownContainer.current.contains(event.target) &&
      !refContactTypeDropDownContainerExclude.current.contains(event.target)
    ) {
      setShowContactDrop(false);
    }
  };
  useEffect(() => {
    if (showContactDrop) {
      window.addEventListener("mousedown", handleMouseDownContactDD);
    } else {
      window.addEventListener("mousedown", handleMouseDownContactDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDownContactDD);
    };
  }, [showContactDrop]);
  const refLanguageContainer = useRef();
  const refLanguageContainerExclude = useRef();
  const handleMouseDownContactLanguage = (event) => {
    if (
      refLanguageContainer.current &&
      !refLanguageContainer.current.contains(event.target) &&
      !refLanguageContainerExclude.current.contains(event.target)
    ) {
      setShowStatusDrop(false);
    }
  };
  useEffect(() => {
    if (showStatusDrop) {
      window.addEventListener("mousedown", handleMouseDownContactLanguage);
    } else {
      window.addEventListener("mousedown", handleMouseDownContactLanguage);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDownContactLanguage);
    };
  }, [showStatusDrop]);
  const refJobTypeDropDownContainer = useRef();
  const refJobTypeDropDownContainerExclude = useRef();
  const handleMouseDownJobDD = (event) => {
    if (
      refJobTypeDropDownContainer.current &&
      !refJobTypeDropDownContainer.current.contains(event.target) &&
      !refJobTypeDropDownContainerExclude.current.contains(event.target)
    ) {
      setShowJobDrop(false);
    }
  };
  useEffect(() => {
    if (showJobDrop) {
      window.addEventListener("mousedown", handleMouseDownJobDD);
    } else {
      window.addEventListener("mousedown", handleMouseDownJobDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDownJobDD);
    };
  }, [showJobDrop]);
  const refPaymentTypeDropDownContainer = useRef();
  const refPaymentTypeDropDownContainerExclude = useRef();
  const handleMouseDowPaymentDD = (event) => {
    if (
      refPaymentTypeDropDownContainer.current &&
      !refPaymentTypeDropDownContainer.current.contains(event.target) &&
      !refPaymentTypeDropDownContainerExclude.current.contains(event.target)
    ) {
      setShowPaymentDrop(false);
    }
  };
  useEffect(() => {
    if (showPaymentDrop) {
      window.addEventListener("mousedown", handleMouseDowPaymentDD);
    } else {
      window.addEventListener("mousedown", handleMouseDowPaymentDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDowPaymentDD);
    };
  }, [showPaymentDrop]);
  const refTypeDropDownContainer = useRef();
  const refTypeDropDownContainerExclude = useRef();
  const handleMouseDowTypeDD = (event) => {
    if (
      refTypeDropDownContainer.current &&
      !refTypeDropDownContainer.current.contains(event.target) &&
      !refTypeDropDownContainerExclude.current.contains(event.target)
    ) {
      setShowTypeDrop(false);
      setShowStatusDrop(false);
    }
  };
  useEffect(() => {
    if (showTypeDrop || showStatusDrop) {
      window.addEventListener("mousedown", handleMouseDowTypeDD);
    } else {
      window.addEventListener("mousedown", handleMouseDowTypeDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDowTypeDD);
    };
  }, [showTypeDrop, showStatusDrop]);
  const roundFileSize = (size, precision) => {
    const units = ["B", "KB", "MB", "GB", "TB"];
    let index = 0;

    while (size >= 1024 && index < units.length - 1) {
      size /= 1024;
      index++;
    }

    return `${Number(size)?.toFixed(precision)} ${units[index]}`;
  };
  const handleDownload = (fileUrl, fileName) => {
    const url = window.URL.createObjectURL(new Blob([fileUrl]));
    const document = window.document || {};
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    // link.href = fileUrl;
    // link.download = fileName;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };
  React.useEffect(() => {
    if (roleModuleData?.status === 200) {
      for (let i = 0; i < roleModuleData?.data?.data?.length; i++) {
        if (
          roleModuleData?.data?.data[i]?.moduleid ===
            "08da4e8a-6050-40db-8d54-5751dc976021" &&
          roleModuleData?.data?.data[i]?.accesslevelsid ===
            "08da33e9-5a64-4f8c-8d88-49e4982df310" &&
          roleModuleData?.data?.data[i]?.featureid ===
            "08da3f0d-0371-4dd3-8c86-e51222d60036"
        ) {
          setRoleOwnerDiseble(true);
        } else if (
          roleModuleData?.data?.data[i]?.moduleid ===
            "08da4e8a-6050-40db-8d54-5751dc976021" &&
          roleModuleData?.data?.data[i]?.accesslevelsid ===
            "08da33e9-5a64-4f8c-8d88-49e4982df310" &&
          roleModuleData?.data?.data[i]?.featureid ===
            "08da3f0d-0371-4dd3-8c86-e51222d60037"
        ) {
          setRoleManagerDiseble(true);
        } else if (
          roleModuleData?.data?.data[i]?.moduleid ===
            "08da4e8a-6050-40db-8d54-5751dc976021" &&
          roleModuleData?.data?.data[i]?.accesslevelsid ===
            "08da33e9-5a64-4f8c-8d88-49e4982df310" &&
          roleModuleData?.data?.data[i]?.featureid ===
            "08da3f0d-0371-4dd3-8c86-e51222d60038"
        ) {
          setRoleUserViewerDiseble(true);
        } else if (
          roleModuleData?.data[i]?.moduleid ==
            "08da4e8a-6050-40db-8d54-5751dc976017" &&
          (roleModuleData?.data[i]?.accesslevelsid ==
            "08da33e9-5a64-4f8c-8d88-49e4982df320" ||
            roleModuleData?.data[i]?.accesslevelsid ==
              "08da33e9-5a64-4f8c-8d88-49e4982df321")
        ) {
          // setShowSetting(true);
        }
      }
    } else {
    }
  }, [roleModuleData]);

  const [calendarIsOpen, setCalendarIsOpen] = useState(false);

  const datePickerFunc = (val) => {
    setStartDate(val);
    setCalendarIsOpen(!calendarIsOpen);
  };
  const [emailError, setEmailError] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setErrorMessage(false);
    setChangeComp(e.target.value);
    let checkEmail = validateEmail(e.target.value);
    if (!checkEmail) {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
  };

  const validateEmail = (email) => {
    // Regular expression for validating an Email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const [jobHover, setJobHover] = useState(false);

  const handleJobName = () => {
    if (jobname && jobname !== "") {
      if (jobname.length <= 12) {
        return jobname;
      } else if (jobname.length > 12 && showJobDrop) {
        return "..." + jobname.slice(-12);
      } else if (jobname.length > 12 && !showJobDrop) {
        return jobname.slice(0, 12) + "...";
      }
      return t("Select ");
    } else {
      return t("Select ");
    }
  };

  const renderError = (error) => {
    return (
      <p
        style={{
          color: "red",
          margin: 0,
          fontSize: "11px",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          justifyContent: "center",
          marginTop: "-1rem",
        }}
      >
        {error}
      </p>
    );
  };

  const handleTabChange = (tab) => {
    const obj = {
      firstName: false,
      email: false,
      password: false,
      initials: false,
    };
    const checkErrors = () => {
      if (!personalForm.firstname) obj.firstName = true;
      if (!personalForm.email) obj.email = true;
      if (!personalForm.initials) obj.initials = true;
      // if (!personalForm.password) obj.password = true;
      if (Object.keys(obj).some((item) => obj[item] === true))
        setNavErrors(obj);
    };
    checkErrors();
    if (tab === "information") {
      setInfomation(true);
      setWage(false);
      setDocument(false);
      setTimeOff(false);
    } else if (
      tab === "wagenrole" &&
      !Object.keys(obj).some((item) => obj[item] === true)
    ) {
      setInfomation(false);
      setWage(true);
      setDocument(false);
      setTimeOff(false);
    } else if (
      tab === "document" &&
      !Object.keys(obj).some((item) => obj[item] === true)
    ) {
      checkErrors();
      setInfomation(false);
      setWage(false);
      setDocument(true);
      setTimeOff(false);
    } else if (
      tab === "timeoff" &&
      !Object.keys(obj).some((item) => obj[item] === true)
    ) {
      checkErrors();
      setInfomation(false);
      setWage(false);
      setDocument(false);
      setTimeOff(true);
    }
  };

  useEffect(() => {
    const sum = Object.values(evenDays).reduce((acc, curr) => {
      if (!isNaN(parseInt(curr))) acc = acc + parseInt(curr);
      else acc += 0;
      return acc;
    }, 0);
    setEvenWorkingHours(sum);
  }, [evenDays]);

  useEffect(() => {
    const sum = Object.values(oddDays).reduce((acc, curr) => {
      if (!isNaN(parseInt(curr))) acc = acc + parseInt(curr);
      else acc += 0;
      return acc;
    }, 0);
    setOddWorkingHours(sum);
  }, [oddDays]);

  const ascTakingDatafromChild = (asc) => {
    setChangeComp(asc);
  };

  return (
    <>
      <Header />
      <RouteLeavingGuard
        when={changeComp !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          if (changeComp !== "") {
            if (!["/member", "/add-member"].includes(location.pathname)) {
              if (location.pathname === "/member-list" && !canGoBack) {
                return true;
              } else if (location.pathname === "/member-list" && canGoBack)
                return false;
              return true;
            }
          }
          return false;
        }}
      />
      <div className="parent">
        <div className="outer mb-2 ">
          <div className="d-flex align-items-center  justify-content-between mb-3">
            <h6
              className="Co-Workers1 ms-1"
              style={{ fontSize: "clamp(20px, 1.354vw, 1.354vw)" }}
            >
              {/* Co-Workers */}
              {t("Co-Workers")}
            </h6>
            <div className="d-flex justify-content-center gap-4 ascHideForMobile">
              <button
                className="canclebtn-add invite-btn-aspect-ratio  cancle-btn-aspect-ratio"
                onClick={handelCancels}
                style={{ wordBreak: "break-all" }}
              >
                {t("Cancel ")}
              </button>
              <button
                className="invitebtn-add-member invite-btn-aspect-ratio"
                onClick={handleChange}
                style={{ wordBreak: "break-all" }}
                disabled={
                  personalForm.firstname &&
                  personalForm.email &&
                  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                    personalForm.email.trim(),
                  ) && // Validate email format.
                  personalForm.initials
                    ? // personalForm.password
                      false
                    : true
                }
              >
                {t("Invite")}
              </button>
            </div>
          </div>
          <div className="row  pb-5 ">
            <div className="col-xl-4 col-lg-12 add-member-leftsid  col-md-12 col-sm-12 col-12 col-xxl-3  ">
              <div
                className="columnfirst-height add-member-leftsid  "
                style={{
                  marginRight: "25px",
                  backgroundColor: "white",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div className="py-4 ">
                    <h4
                      className="headingprofile mt-3"
                      style={{ color: `${textcolor}`, fontWeight: 800 }}
                    >
                      {" "}
                      {t("Profile")}
                    </h4>
                  </div>
                  <div className="pt-4 mt-xxl-5 mt-xl-4 mt-lg-4 mt-sm-4">
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      ref={hiddenFileInput}
                      onChange={(event) => {
                        const fileUploaded = event.target.files[0];
                        if (fileUploaded) {
                          const image = URL.createObjectURL(fileUploaded);
                          setProfilePhoto(image);
                          profileUpload(fileUploaded);
                          setChangeComp(image);
                        } else {
                          return;
                        }
                      }}
                    />
                    {imageUrl ? (
                      <div
                        className="add-profile-image1"
                        style={{
                          border: "1px solid #707070",
                          // minWidth: "240px",
                          // minHeight: "240px",
                          borderRadius: "50%",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                          src={imageUrl}
                          alt=""
                        />
                      </div>
                    ) : personalForm.initials ? (
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <div
                          className="add-profile-image"
                          style={{
                            border: `1px #00256E dashed`,
                            borderRadius: "50%",
                            backgroundColor: "#94a6c7",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                          }}
                        >
                          {personalForm.initials ? personalForm.initials : ""}
                        </div>
                        <div className="d-flex justify-content-center pt-3 ">
                          <h6
                            className="mt-2"
                            style={{
                              fontSize: "12px",
                              cursor: "pointer",
                              color: "#A5A5A5",
                              wordBreak: "break-all",
                            }}
                            onClick={handleClick}
                          >
                            {t("Change")}
                          </h6>
                          <img
                            className="mx-2"
                            style={{ cursor: "pointer" }}
                            src={del}
                            alt="delete"
                            onClick={() => setImageUrl("")}
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        className="add-profile-image"
                        style={{
                          border: `1px #00256E dashed`,
                          // minWidth: "240px",
                          // minHeight: "240px",
                          borderRadius: "50%",
                        }}
                      >
                        <div style={{ marginTop: "30%", cursor: "pointer" }}>
                          <AiOutlinePlus
                            style={{
                              // fontSize: "1.5rem",
                              fontWeight: "bold",
                              color: "#00246A",
                            }}
                            className="responsive-check add-edit-profile-icon"
                            onClick={handleClick}
                          />
                          <br />
                          <p
                            className="company1"
                            onClick={handleClick}
                            style={{
                              fontSize: "clamp(16px, 1.042vw, 1.042vw)",
                            }}
                          >
                            {t("Add a photo")}
                          </p>
                        </div>
                      </div>
                    )}
                    <div className="mt-2" style={{ height: "26px" }}>
                      {imageUrl && (
                        <>
                          <span
                            className=" mt-4"
                            onClick={handleClick}
                            style={{
                              fontSize: "clamp(12px, 0.729vw, 0.729vw)",
                              fontWeight: 400,
                              cursor: "pointer",
                              color: "#A5A5A5",
                            }}
                          >
                            {t("Change")}{" "}
                          </span>

                          <img
                            className="mx-2 delete-img-aspect-ratio"
                            style={{ cursor: "pointer" }}
                            src={del}
                            alt="delete"
                            onClick={() => {
                              if (imageUrl) {
                                setDeleteModalShow(true);
                              }
                            }}
                          />
                        </>
                      )}
                    </div>
                    {/* <img className='profileimage' src={imageurl} alt="profile" /> */}
                  </div>
                  {/* <div className="d-flex justify-content-center pt-3 " >
                  <h6 className='mt-2' style={{ fontSize: "12px" }}>Change</h6>
                  <img className='mx-2' src={del} alt="delete" />
                </div> */}

                  <div className="pt-xxl-4 pt-xl-5 pt-lg-5 pt-sm-4">
                    <input
                      className="noborder2 text-center mt-xxl-5"
                      disabled
                      type="text"
                      // placeholder="Name"
                      placeholder={t("Name")}
                      style={{
                        color: "#333333",
                        fontSize: "clamp(18px, 1.318vw, 1.25vw)",
                        fontWeight: "bold",
                        opacity: 0.5,
                      }}
                      // onChange={(e, value) => {
                      //   setFullName(e.target.value);
                      // }}
                      value={personalForm.firstname}
                    />

                    {/* <h3 style={{ color: `${textcolor}`, fontSize: "18px", fontWeight: "700" }}> {firstName ? `${firstName}` + " " + `${lastName}` : "Name"}</h3> */}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12 col-xxl-9 leftscreen"
              style={{
                backgroundColor: `${backgroundcolor}`,
              }}
            >
              <div
                className="leftscreen-container"
                style={{
                  backgroundColor: "white",
                }}
              >
                <div className="row  " style={{ backgroundColor: "#FAFAFA" }}>
                  <div
                    className="col-6 col-md-3"
                    style={{ background: `${information ? "#FFFFFF" : ""}` }}
                  >
                    <div
                      className={
                        information
                          ? " tagcolor information-add "
                          : "information2-add "
                      }
                      onClick={() => handleTabChange("information")}
                      style={{ fontWeight: "700", height: "88px", width: "" }}
                    >
                      <h6
                        className="ms-4"
                        style={{
                          paddingTop: "40px",
                          fontSize: "clamp(16px, 1.2vw, 0.938vw)",
                          color: `${information ? "#333333" : "#A5A5A5"}`,
                          fontWeight: `${information ? "bold" : 400}`,
                        }}
                      >
                        {t("Information")}
                      </h6>
                      {information && (
                        <div className="horizontal-add ms-4"></div>
                      )}
                    </div>
                  </div>
                  <div className="col-6 col-md-3">
                    <div
                      style={{ fontWeight: "700", height: "88px" }}
                      className={
                        wage
                          ? "tagcolor wage add-member-leftsid"
                          : "wage2 add-member-leftsid"
                      }
                      onClick={() => handleTabChange("wagenrole")}
                    >
                      <h6
                        style={{
                          paddingTop: "40px",
                          fontSize: "clamp(16px, 1.2vw, 0.938vw)",
                          color: `${wage ? "#333333" : "#A5A5A5"}`,
                          fontWeight: `${wage ? "bold" : 400}`,
                        }}
                      >
                        {t("Wage and role")}
                        {wage && <div className="horizontal-roll"></div>}
                      </h6>
                    </div>
                  </div>
                  <div
                    className="col-12 col-sm-6 col-md-3"
                    style={{ background: `${document ? "#FFFFFF" : ""}` }}
                  >
                    <div
                      style={{
                        fontWeight: "700",
                        height: "88px",
                        background: `${document ? "#FFFFFF" : ""}`,
                      }}
                      className={
                        document ? " tagcolor documents " : " documents2 "
                      }
                      onClick={() => handleTabChange("document")}
                    >
                      <div
                        className="me-4"
                        style={{
                          paddingTop: "40px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <h6
                          style={{
                            fontSize: "clamp(16px, 1.2vw, 0.938vw)",
                            color: `${document ? "#333333" : "#A5A5A5"}`,
                            fontWeight: `${document ? "bold" : 400}`,
                          }}
                        >
                          {" "}
                          {t("Documents")}
                          {document && <div className="horizontal-roll"></div>}
                        </h6>
                      </div>
                    </div>
                  </div>
                  {packageID === process.env.REACT_APP_IS_PREMIUM && (
                    <div className="col-6 col-md-3 hidefor-Mobile">
                      <div
                        style={{ fontWeight: "700", height: "88px" }}
                        className={
                          timeOff
                            ? "tagcolor wage add-member-leftsid hidefor-Mobile"
                            : "wage2 add-member-leftsid hidefor-Mobile"
                        }
                        onClick={() => handleTabChange("timeoff")}
                      >
                        <h6
                          style={{
                            paddingTop: "40px",
                            fontSize: "clamp(16px, 1.2vw, 0.938vw)",
                            color: `${timeOff ? "#333333" : "#A5A5A5"}`,
                            fontWeight: `${timeOff ? "bold" : 400}`,
                          }}
                        >
                          {t("Time OFF")}
                          {timeOff && <div className="horizontal-roll"></div>}
                        </h6>
                      </div>
                    </div>
                  )}
                </div>

                {information && (
                  <div style={{ backgroundColor: "white" }}>
                    <div className="px-2 py-3">
                      <SelectNav
                        items={informationNavItems}
                        setSelectedItem={setSelectedInformationNav}
                        selectedItem={selectedInformationNav}
                        setErrors={setNavErrors}
                        personalForm={personalForm}
                      >
                        {selectedInformationNav === "Personal" ||
                        selectedInformationNav === "Persoonlijk" ? (
                          <PersonalInfoForm
                            personalForm={personalForm}
                            setPersonalForm={setPersonalForm}
                            FetchLanguagesData={FetchLanguagesData}
                            errors={navErrors}
                            setErrors={setNavErrors}
                            ascTakingDatafromChild={ascTakingDatafromChild}
                          />
                        ) : selectedInformationNav === "Legal" ||
                          selectedInformationNav === "Juridisch" ? (
                          <LegalInformationForm
                            legalForm={legalForm}
                            setLegalForm={setLegalForm}
                            idsType={idsType}
                            employeeType={employeeType}
                            contractType={contractType}
                            FetchJobtypesdata={FetchJobtypesdata}
                          />
                        ) : selectedInformationNav === "Financial" ||
                          selectedInformationNav === "Financieel" ? (
                          <BankAccountForm
                            bankAccounts={bankAccounts}
                            setBankAccounts={setBankAccounts}
                          />
                        ) : selectedInformationNav === "Benefits" ||
                          selectedInformationNav === "Voordelen" ? (
                          <CompanyCarForm
                            transportForm={transportForm}
                            setTransportForm={setTransportForm}
                            fetchedReasons={fetchedReasons}
                            companyCar={companyCar}
                          />
                        ) : selectedInformationNav === "Certification" ||
                          selectedInformationNav === "Certificering" ? (
                          <CertificationList
                            certificationList={certificationList}
                            setTotalCertifications={setTotalCertifications}
                            totalCertifications={totalCertifications}
                            insertedDoc={insertedDoc}
                          />
                        ) : selectedInformationNav === "Provided Items" ||
                          selectedInformationNav === "Geleverde artikelen" ? (
                          <ProvidedItems
                            providedItems={providedItems}
                            setProvidedItems={setProvidedItems}
                          />
                        ) : (
                          ""
                        )}
                      </SelectNav>
                    </div>
                  </div>
                )}

                {wage && (
                  <div className="" style={{ backgroundColor: "white" }}>
                    <div className="pt-3 mt-2  px-3">
                      <div
                        className="justify-content-between text-align-start wage-role-table-flex"
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fit, minmax(0px, 1fr))",
                          gap: "20px",
                        }}
                      >
                        <div
                          className="row mobileView1"
                          style={{
                            width: "100%",
                          }}
                        >
                          <div className="col-6 col-md-4 col-lg-6">
                            <p className="wage-common-font">{t("Wage rate")}</p>
                            <hr className="mb-2" />
                            <div className="common-font">
                              <CurrencyInput
                                className="noborder2"
                                placeholder="€ 0,00"
                                value={wagerate}
                                ref={refNewStandardWageInput}
                                onChangeEvent={(
                                  event,
                                  maskedvalue,
                                  floatvalue,
                                ) => {
                                  setWagerate(floatvalue);
                                  setChangeComp(event.target.value);
                                }}
                                style={{
                                  color: "#333333",
                                  // width: "150px",
                                  fontSize: "clamp(14px, 1.025vw, 0.833vw)",
                                  fontWeight: "bold",
                                }}
                                decimalSeparator=","
                                thousandSeparator="."
                                precision="2"
                                allowEmpty={true}
                                prefix="€ "
                              />
                            </div>
                          </div>
                          <div className="col-6 col-md-4 col-lg-6">
                            <p
                              className="wage-common-font"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {t("Payment Period")}
                            </p>
                            <hr className="mb-2" />
                            <div className="common-font">
                              <div
                                style={{
                                  cursor: "pointer",
                                  position: "relative",
                                  display: "flex",
                                  flexDirection: "row",
                                  // marginTop:"5px"
                                }}
                              >
                                <div
                                  ref={refPaymentTypeDropDownContainerExclude}
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                  onClick={() =>
                                    setShowPaymentDrop(!showPaymentDrop)
                                  }
                                >
                                  <p
                                    className="margin-0"
                                    style={{
                                      fontSize: "clamp(14px, 1.025vw, 0.833vw)",
                                      fontWeight: "bold",
                                      color: "#333333",
                                      flexGrow: "1",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {paymentperiod
                                      ? paymentperiod
                                      : t("Select ")}
                                  </p>
                                  <BsChevronDown
                                    size={10}
                                    style={{
                                      marginTop: "5px",
                                      flexGlow: "1",
                                      color: "#333333",
                                    }}
                                    className={`${
                                      showPaymentDrop
                                        ? "down-arrow down-arrow-rotate bi-paperclip me-4"
                                        : "down-arrow bi-paperclip me-4"
                                    }`}
                                  />
                                </div>
                                {showPaymentDrop && (
                                  <div
                                    className="drop-down-pyment"
                                    id="lang-drop-down"
                                    ref={refPaymentTypeDropDownContainer}
                                  >
                                    {pymentoptions?.map((item, i) => {
                                      return (
                                        <div
                                          className={
                                            item?.value === paymentperiod
                                              ? " typ-list-select typ-list"
                                              : "typ-list"
                                          }
                                          // className=''
                                        >
                                          <p
                                            key={i}
                                            className="margin-0 ms-3 pb-1"
                                            style={{
                                              opacity: 1,
                                              fontSize:
                                                "clamp(14px, 1.025vw, 0.833vw)",
                                              fontWeight: 400,
                                              color: "#333333",
                                            }}
                                            onClick={() => {
                                              // setStatusId(item.id);
                                              setPaymentperiod(item.value);
                                              setShowPaymentDrop(false);
                                              setChangeComp(item.value);
                                            }}
                                          >
                                            {item.value}
                                          </p>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="row mobileView1"
                          style={{
                            width: "100%",
                          }}
                        >
                          <div className="col-6 col-md-4 col-lg-6">
                            <p className="wage-common-font">
                              {t("Bill Rate ")}
                            </p>
                            <hr className="mb-2" />
                            <div className="common-font">
                              <CurrencyInput
                                className="noborder2"
                                placeholder="€ 0,00"
                                value={billrate}
                                ref={refNewStandardWageInput}
                                onChangeEvent={(
                                  event,
                                  maskedvalue,
                                  floatvalue,
                                ) => {
                                  setBillrate(floatvalue);
                                  setChangeComp(event.target.value);
                                }}
                                style={{
                                  color: "#333333",
                                  fontSize: "clamp(14px, 1.025vw, 0.833vw)",
                                  fontWeight: "bold",
                                }}
                                decimalSeparator=","
                                thousandSeparator="."
                                precision="2"
                                allowEmpty={true}
                                prefix="€ "
                              />
                            </div>
                          </div>

                          <div className="col-6 col-md-4 col-lg-6">
                            <p className="wage-common-font">{t("Type ")}</p>
                            <hr className="mb-2" />
                            <div className="common-font">
                              <div
                                style={{
                                  cursor: "pointer",
                                  position: "relative",
                                  display: "flex",
                                  flexDirection: "row",
                                  // width: "60px",
                                }}
                              >
                                <div
                                  onClick={() => setShowTypeDrop(!showTypeDrop)}
                                  ref={refTypeDropDownContainerExclude}
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <p
                                    className="margin-0 "
                                    style={{
                                      // marginLeft: "3px",
                                      fontSize: "clamp(14px, 1.025vw, 0.833vw)",
                                      fontWeight: "bold",
                                      color: "#333333",
                                      flexGrow: "1",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {type ? type : t("Select ")}
                                  </p>
                                  <BsChevronDown
                                    size={10}
                                    style={{
                                      marginTop: "5px",
                                      flexGlow: "1",
                                      color: "#333333",
                                    }}
                                    className={`${
                                      showTypeDrop
                                        ? "down-arrow down-arrow-rotate bi-paperclip me-4"
                                        : "down-arrow bi-paperclip me-4"
                                    }`}
                                  />
                                </div>
                                {showTypeDrop && (
                                  <div
                                    className="drop-down-pyment"
                                    id="lang-drop-down"
                                    ref={refTypeDropDownContainer}
                                  >
                                    {typeoptions?.map((item, i) => {
                                      return (
                                        <div
                                          className={
                                            item.value === type
                                              ? " typ-list-select typ-list"
                                              : "typ-list"
                                          }
                                          // className=''
                                        >
                                          <p
                                            key={i}
                                            className="margin-0 ms-3 pb-1"
                                            style={{
                                              opacity: 1,
                                              fontSize:
                                                "clamp(14px, 1.025vw, 0.833vw)",
                                              color: "#333333",
                                              fontWeight: 400,
                                              margin: "0px 0px 0px 16px",
                                            }}
                                            onClick={() => {
                                              // setStatusId(item.id);
                                              setType(item.value);
                                              setShowTypeDrop(false);
                                              setChangeComp(item.value);
                                            }}
                                          >
                                            {item.value}
                                          </p>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="row mobileView1"
                          style={{
                            width: "100%",
                          }}
                        >
                          <div className="col-6 col-md-4 col-lg-6">
                            <p className="wage-common-font">
                              {/* Payroll */}
                              {t("Payroll")}
                            </p>
                            <hr className="mb-2" />

                            <input
                              type="checkbox"
                              // checked={item.checked}
                              className="form-check-input pointer companyRadio ms-"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginLeft: "1rem",
                              }}
                              value={payroll}
                              onChange={() => {
                                setPayRoll((prev) => !prev);
                              }}
                            />
                          </div>

                          <div className="col-6 col-md-4 col-lg-6">
                            <p
                              className="wage-common-font"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {t("Timesheet approval")}
                              {/* Timesheet approval */}
                            </p>
                            <hr className="mb-2" />
                            <input
                              type="checkbox"
                              // checked={item.checked}
                              className="form-check-input pointer companyRadio ms-"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginLeft: "1rem",
                              }}
                              value={timesheetapproval}
                              onChange={() => {
                                setTimeSheetApproval((prev) => !prev);
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="my-xxl-5 py-4 hidefor-Mobile">
                        <div
                          style={{
                            backgroundColor: "#e4edfa",
                            display: "flex",
                            flexWrap: "wrap",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px",
                            borderRadius: "10px",
                            fontSize: 13,
                            width: "100%",
                            maxWidth: "100%",
                            overflow: "auto",
                          }}
                        >
                          <div
                            className="py-2"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              fontWeight: 500,
                              width: "40%",
                              gap: "10px",
                            }}
                          >
                            <div>
                              {/* Working Time */}
                              {t("Working Time")}

                              <span
                                style={{ fontWeight: 300, marginLeft: "10px" }}
                              >
                                {/* Total Even week */}
                                {t("Total Even week")}
                              </span>
                            </div>
                            <div>{evenWorkingHours}</div>
                          </div>
                          <div
                            className="py-2"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              fontWeight: 500,
                              width: "40%",
                              gap: "10px",
                            }}
                          >
                            <div>
                              {/* Total Odd week */}
                              {t("Total Odd week")}
                            </div>
                            <div>{oddWorkingHours}</div>
                          </div>
                          <div
                            className="py-2"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: "40px",
                              fontWeight: 300,
                              fontSize: 12,
                            }}
                          >
                            {/* Apply to all year */}
                            {t("Apply to all year")}

                            <input
                              type="checkbox"
                              checked={applyToAllYear}
                              className="form-check-input pointer companyRadio ms-"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginLeft: "1rem",
                              }}
                              onChange={(e) => {
                                setApplyToAllYear((prev) => !prev);
                              }}
                            />
                          </div>
                        </div>
                        <div
                          style={{
                            // backgroundColor: "#e4edfa",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px",
                            fontSize: 13,
                            width: "100%",
                            color: "37f857d",
                            maxWidth: "100%",
                            overflow: "auto",
                          }}
                        >
                          <span
                            style={{
                              margin: 0,
                              marginRight: "10px",
                              fontSize: 12,
                              width: "100%",
                            }}
                          >
                            {" "}
                            {/* Even Week */}
                            {t("Even Week")}
                          </span>
                          {Object.keys(evenDays).map((day, index) => {
                            return (
                              <div
                                index={index}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <div>{day}</div>
                                <input
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor:
                                      evenDays[day] !== 0 ? "#e4edfa" : "white",
                                    color: "#333333",
                                    padding: "10px 30px",
                                    borderRadius: "10px",
                                    border: "1px dashed #e8e8e8",
                                    width: "5.5rem",
                                    fontWeight: 500,
                                  }}
                                  value={evenDays[day]}
                                  onChange={(e) => {
                                    if (
                                      (!isNaN(parseInt(e.target.value)) &&
                                        parseInt(e.target.value) <= 8) ||
                                      e.target.value === ""
                                    ) {
                                      const existing = { ...evenDays };
                                      const day = Object.keys(existing)[index];
                                      existing[day] = e.target.value;
                                      setEvenDays(existing);
                                    }
                                  }}
                                />
                              </div>
                            );
                          })}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px",
                            fontSize: 13,
                            width: "100%",
                            color: "37f857d",
                            maxWidth: "100%",
                            overflow: "auto",
                          }}
                        >
                          <span
                            style={{
                              margin: 0,
                              marginRight: "10px",
                              fontSize: 12,
                              width: "100%",
                            }}
                          >
                            {" "}
                            {/* Odd Week */}
                            {t("Odd Week")}
                          </span>
                          {Object.keys(oddDays).map((day, index) => {
                            return (
                              <div
                                index={index}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <div>{day}</div>
                                <input
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor:
                                      oddDays[day] !== 0 ? "#e4edfa" : "white",
                                    color: "#333333",
                                    padding: "10px 30px",
                                    borderRadius: "10px",
                                    border: "1px dashed #e8e8e8",
                                    width: "5.5rem",
                                    fontWeight: 500,
                                  }}
                                  value={oddDays[day]}
                                  onChange={(e) => {
                                    if (
                                      (!isNaN(parseInt(e.target.value)) &&
                                        parseInt(e.target.value) <= 8) ||
                                      e.target.value === ""
                                    ) {
                                      const existing = { ...oddDays };
                                      const day = Object.keys(existing)[index];
                                      existing[day] = e.target.value;
                                      setOddDays(existing);
                                    }
                                  }}
                                />
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <div className="mt-5 pt-xxl-4 pt-xl-5 pt-lg-5 pb-5">
                        <div className="text-start">
                          <p className="wage-common-font ms-2 mt-4">
                            {t("Authorisation Role")}
                          </p>
                        </div>
                        <div className="row" aria-disabled>
                          <div className="col-9">
                            <div
                              className="row roles-options roles-options-onmobile"
                              style={{ marginLeft: "0px" }}
                            >
                              <Col className="p-0" style={{ height: "100%" }}>
                                <p
                                  style={
                                    roleid === process.env.REACT_APP_IS_OWNER
                                      ? { backgroundColor: `#00246A` }
                                      : { backgroundColor: `` }
                                  }
                                  className={
                                    roleid === process.env.REACT_APP_IS_OWNER
                                      ? "role-single-add authorisation-roles active-role active-role-response"
                                      : roleAccess ===
                                          process.env.REACT_APP_IS_MANAGER
                                        ? "pointerEvent role-single-add wage-authorisation-roles"
                                        : "role-single-add wage-authorisation-roles "
                                  }
                                  onClick={() => {
                                    if (roleOwnerDiseble) {
                                      setAuthorisationRole("Owner");
                                      setRoleid(
                                        "08da3f0d-0371-4dd3-8c86-e51222d56188",
                                      );
                                      setChangeComp(
                                        process.env.REACT_APP_IS_OWNER,
                                      );
                                    }
                                  }}
                                >
                                  {t("Owner")}
                                </p>
                              </Col>
                              <Col style={{ height: "100%" }}>
                                <p
                                  style={
                                    roleid ===
                                    "08da3f0d-0371-4dd3-8c86-e51222d56199"
                                      ? { backgroundColor: `#00246A` }
                                      : { backgroundColor: `` }
                                  }
                                  className={
                                    roleid === process.env.REACT_APP_IS_MANAGER
                                      ? "role-single-add wage-authorisation-roles active-role active-role-response"
                                      : "role-single-add wage-authorisation-roles "
                                  }
                                  onClick={() => {
                                    if (
                                      roleManagerDiseble ||
                                      roleOwnerDiseble
                                    ) {
                                      setAuthorisationRole("Manager");
                                      setRoleid(
                                        "08da3f0d-0371-4dd3-8c86-e51222d56190",
                                      );
                                      setChangeComp(
                                        "08da3f0d-0371-4dd3-8c86-e51222d56190",
                                      );
                                    }
                                  }}
                                >
                                  {t("Manager")}
                                </p>
                              </Col>
                              <Col style={{ height: "100%" }}>
                                <p
                                  style={
                                    roleid === process.env.REACT_APP_IS_USER
                                      ? { backgroundColor: `#00246A` }
                                      : { backgroundColor: `` }
                                  }
                                  className={
                                    roleid === process.env.REACT_APP_IS_USER
                                      ? "role-single-add wage-authorisation-roles active-role active-role-response"
                                      : "role-single-add wage-authorisation-roles "
                                  }
                                  onClick={() => {
                                    if (
                                      roleManagerDiseble ||
                                      roleOwnerDiseble
                                    ) {
                                      setAuthorisationRole("User");
                                      setRoleid(
                                        "08da3f0d-0371-4dd3-8c86-e51222d56189",
                                      );
                                      setChangeComp(
                                        "08da3f0d-0371-4dd3-8c86-e51222d56189",
                                      );
                                    }
                                  }}
                                >
                                  {t("User")}
                                </p>
                              </Col>
                              <Col className="p-0" style={{ height: "100%" }}>
                                <p
                                  style={
                                    roleid === process.env.REACT_APP_IS_VIEWER
                                      ? { backgroundColor: "#00246A" }
                                      : { backgroundColor: `` }
                                  }
                                  className={
                                    roleid === process.env.REACT_APP_IS_VIEWER
                                      ? "role-single-add wage-authorisation-roles active-role active-role-response"
                                      : "role-single-add wage-authorisation-roles "
                                  }
                                  onClick={() => {
                                    if (
                                      roleManagerDiseble ||
                                      roleOwnerDiseble
                                    ) {
                                      setAuthorisationRole("Freelancer");
                                      setRoleid(
                                        "08da3f0d-0371-4dd3-8c86-e51222d56191",
                                      );
                                      setChangeComp(
                                        process.env.REACT_APP_IS_VIEWER,
                                      );
                                    }
                                  }}
                                >
                                  {t("Viewer")}
                                </p>
                              </Col>
                            </div>
                          </div>
                          <div className="col-3 "></div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {document && (
                  <div
                    className="m-4 mt-3"
                    style={{ backgroundColor: "white" }}
                  >
                    <SelectNav
                      items={documentNavItems}
                      setSelectedItem={setSelectedDocumentNav}
                      selectedItem={selectedDocumentNav}
                      screen="documents"
                    >
                      <div style={{ width: "100%" }}>
                        <div
                          className="table-doc-info"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div className="d-flex pt-1">
                            <DocumentUploaderWithProgress
                              maxSizeInMb={100}
                              onUploaded={onFileUploaded}
                            >
                              <label
                                htmlFor="add-attachment"
                                className="mx"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                              >
                                <img
                                  src={adddoc}
                                  alt="addicons"
                                  className="mb-3 plus-icon-aspect-ratio"
                                />
                                <p
                                  className="mx-2 ft"
                                  style={{
                                    fontSize: "clamp(12px, 0.833vw, 0.833vw)",
                                  }}
                                >
                                  {t("Add doc")}
                                </p>
                              </label>
                            </DocumentUploaderWithProgress>
                          </div>
                          <div className="custom-pagination">
                            <div className="pagination-buttons">
                              <div
                                className={`pagination-button ${
                                  paginationObj.currentPage === 1
                                    ? "disabled"
                                    : ""
                                }`}
                                onClick={() =>
                                  calculatePagination(
                                    paginationObj.currentPage - 1,
                                  )
                                }
                              >
                                <BsChevronLeft />
                              </div>
                              <div className="pagination-current-page">
                                {paginationObj.currentPage}
                              </div>
                              <div
                                className={`pagination-button ${
                                  paginationObj.totalPages === 0 ||
                                  paginationObj.totalPages ===
                                    paginationObj.currentPage
                                    ? "disabled"
                                    : ""
                                }`}
                                onClick={() =>
                                  calculatePagination(
                                    paginationObj.currentPage + 1,
                                  )
                                }
                              >
                                <BsChevronRight />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div
                            className="col-5 ft document-header"
                            style={{ textAlign: "initial" }}
                          >
                            {t("Name ")}
                          </div>
                          <div className="col-2 ft document-header hidefor-Mobile">
                            {" "}
                            {t("Size ")}{" "}
                          </div>
                          <div className="col-3 ft document-header hidefor-Mobile">
                            {t("Date")}{" "}
                          </div>
                          <div className="col-2 ft text-start document-header hidefor-Mobile">
                            {t("Sender")}
                          </div>
                        </div>
                        <hr
                          style={{
                            width: "90%px",
                            border: "0.5px dashed #C0C5C5",
                          }}
                          className="my-1"
                        />

                        <div
                          className=""
                          style={{
                            height: " 260px",
                            overflow: "hidden auto",
                          }}
                        >
                          {paginationObj.records?.map((item, i) => {
                            const filesize1 = (
                              item?.documentsize / 1024
                            ).toString();

                            return (
                              <>
                                <div className="row py-1" key={i}>
                                  <div
                                    className="col-9 col-md-5 col-sm-6 ps-1 ft"
                                    style={{ cursor: "default" }}
                                  >
                                    <LightTooltip
                                      disableHoverListener={
                                        item.documentname?.length > 30
                                          ? false
                                          : true
                                      }
                                      title={item.documentname}
                                      placement="top-start"
                                    >
                                      <div
                                        style={{ width: "16vw" }}
                                        className="add-member-truncated-text1 document-content"
                                        onClick={() => {
                                          handleDownload(
                                            item?.link,
                                            item?.documentname,
                                          );
                                        }}
                                      >
                                        {item.documentname}
                                      </div>
                                    </LightTooltip>
                                  </div>
                                  <div className="col-2 add-member-ft document-content hidefor-Mobile">
                                    {roundFileSize(item?.documentsize, 2)}
                                  </div>
                                  <div className="col-3 add-member-ft document-content hidefor-Mobile">
                                    {moment(new Date()).format("DD.MM.YYYY")}
                                  </div>
                                  <div
                                    className="col-1 add-member-ft pe-4 hidefor-Mobile"
                                    style={{
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    {userimag ? (
                                      <img
                                        style={{
                                          width: "clamp(20px, 1vw, 1vw)",
                                          height:
                                            "clamp(20px, 2.6852vh, 2.6852vh)",
                                          borderRadius: "50%",
                                        }}
                                        alt="senderimg"
                                        src={userimag}
                                      />
                                    ) : (
                                      <div
                                        className=" me-1"
                                        style={{
                                          width: "clamp(20px, 1.51vw, 1.51vw)",
                                          height:
                                            "clamp(20px, 2.6852vh, 2.6852vh)",
                                          borderRadius: "50%",
                                          objectFit: "cover",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",

                                          color: "#FFFFFF",
                                          fontsize:
                                            "clamp(14px, 0.833vw, 0.833vw)",
                                          fontWeight: 400,
                                          background:
                                            "#95A7C6 0% 0% no-repeat padding-box",
                                        }}
                                      >
                                        {userfirstname?.toUpperCase()
                                          ? userfirstname
                                              .slice(0, 1)
                                              .toUpperCase() +
                                            userlastname
                                              .slice(0, 1)
                                              .toUpperCase()
                                          : userfirstname
                                              ?.slice(0, 1)
                                              .toUpperCase() +
                                            userfirstname
                                              ?.slice(1, 2)
                                              .toUpperCase()}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-1 ft">
                                    <img
                                      src={del}
                                      alt=" Delete Images"
                                      className="me-5"
                                      style={{
                                        width: "clamp(17px, 1.146vw, 1.146vw)",
                                        height:
                                          "clamp(18px, 2.3148vh, 2.3148vh)",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        setDeleteRowIndex(i);
                                        setDeleteDocument(true);
                                      }}
                                    />
                                  </div>
                                </div>
                              </>
                            );
                          })}
                        </div>
                      </div>
                      {/* ) : (
                        ""
                      )} */}
                    </SelectNav>
                  </div>
                )}

                {timeOff && (
                  <TimeOffScreen
                    timeOffEntries={timeOffEntries}
                    setTimeOffEntries={setTimeOffEntries}
                    FetchUserData={FetchUserData}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center gap-4 mb-2 addcancelbttna">
          <button
            className="canclebtn-add invite-btn-aspect-ratio cancle-btn-aspect-ratio d-none upperADD_CancelBtnShoeHide_Mobile"
            onClick={handelCancels}
            style={{ wordBreak: "break-all" }}
          >
            {t("Cancel ")}
          </button>
          <button
            className="invitebtn-add-member invite-btn-aspect-ratio d-none upperADD_CancelBtnShoeHide_Mobile"
            onClick={handleChange}
            style={{ wordBreak: "break-all" }}
          >
            {t("Invite")}
          </button>
        </div>
      </div>

      {popups && (
        <Modal
          show={popups}
          className="modelwidth12-add modal-dialog1-add"
          style={{
            backgroundColor: "transparent",
            opacity: 0.9,
          }}
          id="update-member-modal-add"
          centered
        >
          <Modal.Body>
            <div className="flex_class my-5">
              <div
                className=""
                style={{ color: "#333333", fontSize: "14px", fontWeight: 700 }}
              >
                {t("The changes made will not be saved.")}
              </div>

              <div
                className=" mt-4"
                style={{ color: "#333333", fontSize: "14px", fontWeight: 700 }}
              >
                {t("Do you want to proceed?")}
              </div>

              <div className="mt-5 ">
                <button
                  className="me-2 w-25 btn-no-add-edit-member"
                  onClick={() => {
                    setPopups(false);
                  }}
                  style={{ fontWeight: 800 }}
                >
                  {t("No")}
                </button>
                <button
                  className="ms-2 w-25 btn-yes-add-edit-member"
                  onClick={() => {
                    dispatch({ type: "USER_CREATE", data: {} });
                    history.push("/member-list");
                  }}
                  style={{ fontWeight: 800 }}
                >
                  {t("Yes")}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}

      {deleteModalShow && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteFun}
          show={deleteModalShow}
          onHide={() => setDeleteModalShow(false)}
          title1={"This data will be removed from the system"}
          title2={"and cannot be undone."}
          title3={t("Do you want to proceed?")}
          no={t("No")}
          yes={t("Yes")}
        />
      )}

      {deleteDocument && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteDocumentFun}
          show={deleteDocument}
          onHide={() => setDeleteDocument(false)}
          title1={"This data will be removed from the system"}
          title2={"and cannot be undone."}
          title3={t("Do you want to proceed?")}
          no={t("No")}
          yes={t("Yes")}
        />
      )}
    </>
  );
};

export default AddMember;
